import { useState, useEffect, useRef } from "react";

const createPersistentStore = () => {
  if (typeof window !== "undefined") {
    if (!window.__tabStateStore) {
      window.__tabStateStore = new Map();
    }
    return window.__tabStateStore;
  }
  return new Map();
};

const usePersistedTabState = (key, defaultValue) => {
  const storeRef = useRef(createPersistentStore());

  const [state, setState] = useState(() => {
    const store = storeRef.current;
    const saved = store.get(key);
    // console.log(`Loading persisted state for ${key}:`, saved); // Debug log
    return saved !== undefined ? saved : defaultValue;
  });

  useEffect(() => {
    const store = storeRef.current;
    // console.log(`Saving state for ${key}:`, state); // Debug log
    store.set(key, state);
  }, [key, state]);

  return [state, setState];
};

export default usePersistedTabState;
